import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ClientTherapyPlanListItemDto } from '@client/shared/models/therapy-plan/client-therapy-plan-list-item.dto';
import { environment } from '../../../../environments/environment';
import { ClientTherapyPlanDto } from '@client/shared/models/therapy-plan/client-therapy-plan.dto';
import { ClientTherapyPlanProgressDto } from '@client/shared/models/therapy-plan/client-therapy-plan-progress.dto';

@Injectable({ providedIn: 'root' })
export class ClientTherapyPlanApiService {

  readonly #http = inject(HttpClient);

  private get endpoint() {
    return `${environment.basePath}/therapy-plan/consumption`;
  }

  getAll(): Observable<ClientTherapyPlanListItemDto[]> {
    return this.#http.get<ClientTherapyPlanListItemDto[]>(`${this.endpoint}`);
  }

  getById(therapyPlanId: string): Observable<ClientTherapyPlanDto> {
    return this.#http.get<ClientTherapyPlanDto>(`${this.endpoint}/${therapyPlanId}`);
  }

  getTherapyPlanProgress(therapyPlanId: string): Observable<ClientTherapyPlanProgressDto> {
    return this.#http.get<ClientTherapyPlanProgressDto>(`${this.endpoint}/${therapyPlanId}/progress`);
  }

  updateExerciseProgress(exerciseId: string): Observable<ClientTherapyPlanProgressDto> {
    return this.#http.put<ClientTherapyPlanProgressDto>(`${this.endpoint}/${exerciseId}/add-progress`,null);
  }
}
